import React, { lazy, Suspense } from 'react';
import { useTheme } from '@mui/material/styles';

const AmbassadorIcon = lazy(() =>
  import('assets/icons/daily/achievement/badge-ambassador.svg?react')
);
const CandidateIcon = lazy(() =>
  import('assets/icons/daily/achievement/badge-candidate.svg?react')
);
const CommenterIcon = lazy(() =>
  import('assets/icons/daily/achievement/badge-commenter.svg?react')
);
const LearnerIcon = lazy(() =>
  import('assets/icons/daily/achievement/badge-learner.svg?react')
);
const ReaderfIcon = lazy(() =>
  import('assets/icons/daily/achievement/badge-readerf.svg?react')
);
const WatcherIcon = lazy(() =>
  import('assets/icons/daily/achievement/badge-watcher.svg?react')
);
const CoinIcon = lazy(() => import('assets/icons/daily/coin.svg?react'));

const GetAchievementIcon = ({ achievement }) => {
  const theme = useTheme();
  const LazyComponent = {
    ambassador: AmbassadorIcon,
    candidate: CandidateIcon,
    commenter: CommenterIcon,
    newby: LearnerIcon,
    reader: ReaderfIcon,
    viewer: WatcherIcon,
    referFriend: CoinIcon
  }[achievement];

  return LazyComponent ? (
    <Suspense
      fallback={<div style={{ width: 24, height: 24, background: theme.palette.grey[300] }} />}>
      <LazyComponent />
    </Suspense>
  ) : null;
};

const getAchievementIcon = (achievement) => {
  return <GetAchievementIcon achievement={achievement} />;
};

export { getAchievementIcon };
